// Presigned uploads in demo mode: POST /upload hands out `demo://upload/<id>`, the
// upload service "uploads" by keeping a local object URL, and an org saved with that
// asset id shows the picked logo for the rest of the tab session.

import { ids } from '../core';

let uploadCount = 0;
let objectUrls = new Map<string, string>();

export const DEMO_UPLOAD_SCHEME = 'demo://upload/';

export function resetUploads(): void {
  for (const url of objectUrls.values()) {
    try {
      URL.revokeObjectURL(url);
    } catch {
      /* not a blob url */
    }
  }
  objectUrls = new Map();
  uploadCount = 0;
}

export function createPresignedUpload(fileType: string, extension: string): { id: string; upload_url: string; file_path: string } {
  uploadCount += 1;
  const id = ids.upload(uploadCount);
  return {
    id,
    upload_url: `${DEMO_UPLOAD_SCHEME}${id}`,
    file_path: `${fileType || 'upload'}/${id}.${extension || 'png'}`,
  };
}

/** Called by the upload service instead of a network PUT. */
export function registerDemoUpload(uploadUrl: string, file: Blob): void {
  const id = uploadUrl.startsWith(DEMO_UPLOAD_SCHEME) ? uploadUrl.slice(DEMO_UPLOAD_SCHEME.length) : uploadUrl;
  try {
    objectUrls.set(id, URL.createObjectURL(file));
  } catch {
    /* no object URLs (tests): the asset id still resolves, just without a preview */
  }
}

export function uploadedObjectUrl(assetId: string): string | null {
  return objectUrls.get(assetId) ?? null;
}
